import { createReducer } from '../helpers';
import { api, clearAudienceStore, setAudienceFilter } from '../actions';

const setIsFetching = (bool) => (state) => {
    state.isFetching = bool;
};

const initialState = {
    isFetching: false,
    filter: {},
    items: [],
    next: null,
};

export default createReducer(initialState, {
    [api.websites.audience.list.request]: setIsFetching(true),
    [api.websites.audience.list.failure]: setIsFetching(false),
    [api.websites.audience.list.success]: (state, { result, query }) => {
        state.next = result.next;
        state.isFetching = false;

        if (query?.next) {
            state.items.push(...result.results);
        } else {
            state.items = result.results;
        }
    },

    [setAudienceFilter]: (state, action) => {
        state.filter = action.payload || {};
        state.next = null;
    },

    [clearAudienceStore]: () => initialState,
});
